import { io } from "socket.io-client";
import { socket_url } from "./connection_strings";
import { getAccessToken } from "./authHeader";

let tokenUsedForConnection = null;

// auth as a function is re-evaluated on every (re)connect, so a token set after login is picked up.
const readAuth = (cb) => {
  tokenUsedForConnection = getAccessToken() || null;
  cb({ token: tokenUsedForConnection });
};

export const socket = io(socket_url, {
  autoConnect: true,
  transports: ["websocket", "polling"],
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  auth: readAuth,
});

// A renewed token belongs to the same session, so the live connection is kept; the next reconnect sends it.
window.addEventListener("muvrrs:token-renewed", () => {
  if (socket.connected) tokenUsedForConnection = getAccessToken() || null;
});

export const refreshSocketAuth = () => {
  if (!socket.connected) {
    socket.connect();
    return;
  }
  // Only reconnect when the login token changed, otherwise joined rooms would be dropped.
  if ((getAccessToken() || null) !== tokenUsedForConnection) {
    socket.disconnect().connect();
  }
};
